import React, { useState, useEffect, ChangeEvent, useRef } from 'react'
import forEach from 'lodash/forEach'
import includes from 'lodash/includes'
import Icon from '../../Shared/Components/Icon'
import InlineLink from '../../Shared/Components/Links/InlineLink'
import { LinkType } from '../../Shared/Components/Links/types'
import { MapSearchFilterProps } from './types'
import {
    formatRecyclingOptions,
    IconForOption,
    formatSelectedString
} from '../utils'
import {
    InputSelectMode,
    InputSelectOption,
} from '../../Shared/Components/InputSelect/types'
import { useTranslation } from 'react-i18next'
import { StandaloneSearchBox } from '@react-google-maps/api'
import InputSearch from '../../Shared/Components/InputSearch'
import InputSelect from '../../Shared/Components/InputSelect'
import './Scss/_map-search-filter.scss'

const MapSearchFilter = (props: MapSearchFilterProps) => {
    const { t } = useTranslation();
    const searchBox = useRef<StandaloneSearchBox>(null);

    const [selectedOptions, setSelectedOptions] = useState<InputSelectOption[]>(
        []
    );
    const [searchTerm, setSearchTerm] = useState<string>('');
    const recyclingOptions = formatRecyclingOptions(props.recyclingOptions);
    const defaultSelectedValues = props.defaultSelectedAlternatives || [];
    const selectedString = formatSelectedString(selectedOptions);

    const onChangeSearchTerm = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchTerm(value);
    }

    const onPlacesChanged = () => {
        if (searchBox && searchBox.current && searchBox.current.state) {
            const searchboxref = searchBox.current.state.searchBox;
            const places = searchboxref && searchboxref.getPlaces();
            props.onSearchSelection((places && places[0]) || undefined);
        }
    }

    const onChangeRecyclingOptions = (selection: InputSelectOption[]) => {
        setSelectedOptions(selection);
        props.filterStations(selection);
    }

    useEffect(() => {
        const newSelected: InputSelectOption[] = [];
        forEach(recyclingOptions, option => {
            if (includes(defaultSelectedValues, option.value)) {
                newSelected.push(option);
            }
        });
        setSelectedOptions(newSelected);
    }, []);

    return (
        <div className='map-search-filter'>
            <div className='map-search-filter__input-fields'>
                {props.showSearch && (
                    <StandaloneSearchBox
                        onPlacesChanged={onPlacesChanged}
                        ref={searchBox}>
                        <InputSearch
                            id={`${props.idPrefix}map-search-field`}
                            label={t('recyclingStations.mapSearchLabel')}
                            value={searchTerm}
                            onChange={onChangeSearchTerm}
                            placeholder={t(
                                'recyclingStations.mapSearchPlaceholder'
                            )}
                        />
                    </StandaloneSearchBox>
                )}
                <InputSelect
                    allowInput={false}
                    id={`${props.idPrefix}map-deposit-options-field`}
                    mode={InputSelectMode.Multiple}
                    label={t('recyclingStations.mapRecyclingOptionsLabel')}
                    options={recyclingOptions || []}
                    value={selectedOptions || []}
                    onChange={onChangeRecyclingOptions}
                    hideLabel={true}
                    className="map-deposit-options-field"
                />
            </div>

            <div className='map-search-filter__info'>
                <InlineLink
                    id={`${props.idPrefix}map-open-options-modal-link`}
                    text={props.modalLinkText || ''}
                    type={LinkType.Intern}
                    url=""
                    hideIcon={true}
                    onClick={props.openRecyclingOptionsModal}
                />
                {props.recyclingOptions.map(option => {
                    return (
                        <Icon
                            key={`icon-${option}`}
                            iconName={IconForOption[option as keyof typeof IconForOption]}
                            size={28}
                            color={'0094bf'}
                        />
                    );
                })}
            </div>

            <div className='map-search-filter__selection-fade-area'>
                <span>{t('recyclingStations.showing')}</span>
                <span>{selectedString}</span>
            </div>
        </div>
    )
}

export default MapSearchFilter